import _defineProperty from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import { computed, defineComponent, reactive, ref } from "vue";
import { useI18n } from "vue-i18n"; // helpers

import { convertCodeToNameLang, convertIdToNameLang } from "@/utils/helpers/lang";
import { zipCode } from "@/utils/validate";
import CustomersModule from "@/store/modules/customers";
import MazPhoneNumberInput from "maz-ui/components/MazPhoneNumberInput";
import POSConfigModule from "@/store/modules/pos-config";
export default defineComponent({
  name: "CustomerEditForm",
  components: {
    MazPhoneNumberInput: MazPhoneNumberInput
  },
  setup: function setup() {
    var _POSConfigModule$grou;

    var _useI18n = useI18n({
      useScope: "global"
    }),
        t = _useI18n.t;

    var form = ref();
    var results = ref();
    var fullName = CustomersModule.editedCustomer[0].fullName.split(" ").reduce(function (acc, rec, index) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, "name".concat(index + 1), rec));
    }, {});
    var _CustomersModule$edit = CustomersModule.editedCustomer[0],
        firstName = _CustomersModule$edit.firstName,
        lastName = _CustomersModule$edit.lastName; // get the group's country code

    var groupBranding = (_POSConfigModule$grou = POSConfigModule.groupInfo) === null || _POSConfigModule$grou === void 0 ? void 0 : _POSConfigModule$grou.brandingList;
    var groupCountry;

    if (groupBranding && groupBranding[0] && groupBranding[0].country) {
      groupCountry = groupBranding[0].country.alpha2;
    } else {
      groupCountry = "CH";
    } // supplied language can be the language code or id, depends on whether you're fetching customer from the booking or appsearch


    var language = convertCodeToNameLang(CustomersModule.editedCustomer[0].language) || convertIdToNameLang(CustomersModule.editedCustomer[0].language);
    var ruleForm = reactive({
      title: CustomersModule.editedCustomer[0].title || "",
      firstName: firstName || fullName.name1 || "",
      lastName: lastName || fullName.name2 || "",
      email: CustomersModule.editedCustomer[0].email || "",
      language: language,
      allergies: CustomersModule.editedCustomer[0].allergies || "",
      address: CustomersModule.editedCustomer[0].address || "",
      zipCode: CustomersModule.editedCustomer[0].zipCode || "",
      city: CustomersModule.editedCustomer[0].city || "",
      country: CustomersModule.editedCustomer[0].country || groupCountry,
      company: CustomersModule.editedCustomer[0].company || "",
      id: CustomersModule.editedCustomer[0].id || "",
      phone: CustomersModule.editedCustomer[0].phone || "",
      birthDate: CustomersModule.editedCustomer[0].birthDate || "",
      emailMarketingOrganiser: CustomersModule.editedCustomer[0].emailMarketingOrganiser ? 1 : 0
    });
    var rules = reactive({
      firstName: [{
        required: true,
        message: t("field.first-name-empty"),
        trigger: "change"
      }, {
        max: 45,
        min: 2,
        message: t("field.first-name-min-max"),
        trigger: "change"
      }],
      lastName: [{
        required: true,
        message: t("field.last-name-empty"),
        trigger: "change"
      }, {
        max: 45,
        min: 2,
        message: t("field.last-name-min-max"),
        trigger: "change"
      }],
      email: [{
        required: true,
        message: t("field.email-required"),
        trigger: "blur"
      }, {
        type: "email",
        message: t("field.email-invalid"),
        trigger: ["blur", "change"]
      }],
      language: {
        required: true,
        message: t("field.language-empty"),
        trigger: "change"
      },
      company: {
        max: 50,
        message: t("field.company-max"),
        trigger: "change"
      },
      city: [{
        max: 50,
        message: t("field.city-max"),
        trigger: "change"
      }],
      zipCode: [{
        pattern: zipCode,
        message: t("field.zip-code-invalid"),
        trigger: "change"
      }],
      phone: [{
        validator: checkPhoneNumber,
        trigger: "change"
      }, {
        required: false,
        trigger: "change"
      }]
    });
    /**
     * Used to be considered in the rules array to validate the phone number
     */

    function checkPhoneNumber() {
      // We validate if there is avalue entered by the user
      if (results.value) {
        if (results.value.nationalNumber) return results.value.isValid;
      } // We don't let the phone validator we're using assign undefined value to phone field when it has empty string
      // beause it will never be considered and the user will never be able to empty a phone number from a customer


      if (!ruleForm.phone) ruleForm.phone = ""; // We don't validate if there is no phone entered

      return true;
    }

    var GET_YES_NO_CONTENT = computed(function () {
      return [{
        value: 0,
        label: t("common.no")
      }, {
        value: 1,
        label: t("common.yes")
      }];
    });
    return {
      form: form,
      ruleForm: ruleForm,
      rules: rules,
      fullName: fullName,
      results: results,
      GET_YES_NO_CONTENT: GET_YES_NO_CONTENT
    };
  }
});